import { useEffect } from "react";
import RecentTransactionsPage from "components/pages/RecentTransactionsPage";

export default function CaptureTransactionList(props) {
    // Modifies data point values so that different transactions
    // for different cards can be referenced by 1 endpoint label in capture states.
    useEffect(() => {
        const merchantNameDebit = document.querySelector('[data-point="Transaction_5_Name_Label"]');
        const merchantNameCredit = document.querySelector('[data-point="Transaction_98_Name_Label"]');
        const dataPoint = "Transaction_Disputed_Transaction_Name_Label";
        if(merchantNameDebit) {
            merchantNameDebit.setAttribute("data-point", dataPoint);
        }
        if(merchantNameCredit) {
            merchantNameCredit.setAttribute("data-point", dataPoint);
        }
    });

    return (
        <RecentTransactionsPage/>
    );
}
